import { render, staticRenderFns } from "./SelectTopics.vue?vue&type=template&id=c8798e74&scoped=true&"
import script from "./SelectTopics.vue?vue&type=script&lang=js&"
export * from "./SelectTopics.vue?vue&type=script&lang=js&"
import style0 from "./SelectTopics.vue?vue&type=style&index=0&id=c8798e74&scoped=true&lang=scss&"
import style1 from "./SelectTopics.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./SelectTopics.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8798e74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VFadeTransition,VIcon,VProgressLinear,VRow,VSnackbar,VSpacer,VTextField,VTooltip})
